// extracted by mini-css-extract-plugin
module.exports = {"formbackground":"#f1f1f1","gridPadding":"25px 50px","fontcolor":"rgba(0,0,0,0.678431)","titlepadding":"20px 50px","commonTheme":"#3169fb"};